// state
const state = {
    isOpen: false
};

// getters
const getters = {};

// actions
const actions = {
    set({ commit }, value) {
        commit('setIsOpen', value);
    },
    open({ commit }) {
        commit('setIsOpen', true);
    },
    close({ commit }) {
        commit('setIsOpen', false);
    }
};

// mutations
const mutations = {
    setIsOpen(state, event) {
        state.isOpen = event;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
